import React from 'react';
import Navbar from './global-components/navbar-v4';
import AboutV2 from './section-components/about-v2';
import Featuresv1 from './section-components/features-v1';
import Gallery   from './section-components/gallery-v1';
import Apartment from './section-components/apartment-v1';
import VideoV1 from './section-components/video-v1';
import Category from './section-components/category-v1';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import Contact from './contact';
import Banner from './section-components/banner-v3';


const Diamantine = () => {
    return <div>
        <Navbar /> 
        <Banner 
        title={"Diamantine"}
        subtitle={"une adresse d’exception"}
        description={"Des appartements aux finitions haut standing, pour vivre ou investir dans un cadre privilégié à deux pas de toutes les commodités, au cœur de la ville de Tanger."}
        btn={"Découvrir plus"} />      

        <AboutV2 />
        <Gallery />
        <Featuresv1 customClass="ltn__feature-area section-bg-1 pt-120 pb-90 mb-120---"/>
        {/* <ProSlider /> */}
        <Apartment />
        <VideoV1 />
        <Category />
        {/* <Testimonial /> */}
        <Contact/>
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Diamantine

